var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps-container"},[_c('b-steps',{attrs:{"active":_vm.activeStep,"small":""}},[_c('b-step',{attrs:{"title":"Step 1","description":"Select Items"}}),_c('b-step',{attrs:{"title":"Step 2","description":"Review Selection"}}),_c('b-step',{attrs:{"title":"Step 3","description":"Submit"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }